import React from 'react'
import { useTranslate, Button, useRecordContext } from 'react-admin'
import { Box, Typography } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import get from 'lodash/get'

export const TrainPassesTicket = ({ source_ticket_url, source_status }) => {
  const translate = useTranslate()
  const record = useRecordContext()
  const ticket_url = get(record, source_ticket_url)
  const status = get(record, source_status)
  
  if (
    ticket_url &&
    Array.isArray(ticket_url) &&
    ticket_url.length > 0 &&
    status === 'INVOICED' &&
    ticket_url.every((record) => 'url' in record)
  ) {
    return (
      <Box>
        <Typography variant='h7' component='div' textAlign={'center'} fontWeight={600}>
          {translate('ra.title.tickets')}
        </Typography>
        <Box display={'flex'} width={'100%'}>
          {ticket_url.filter((elem) => !elem?.url?.endsWith('.pkpass')).map((elem, key) => {
            return (
              elem?.url && (
                <Button
                  key={key}
                  component='a'
                  href={`${elem?.url}`}
                  style={{ width: 'auto', margin: '0 5px 0 5px' }}
                  size='medium'
                  target='_blank'
                  rel='noopener noreferrer'
                  variant='contained'
                  onClick={(e) => e.stopPropagation()}
                >
                  <PictureAsPdfIcon /> Ticket
                </Button>
              )
            )
          })}
        </Box>
      </Box>
    )
  } 
}
